import glamorous from 'glamorous';

const H1 = glamorous('h1')(({ theme }) => ({
    fontSize: '4.6rem',
    marginBottom: theme.space_sm,
}));

export default H1;
